import _sortBy from "lodash/sortBy";
export const lineChartDetails = [{
  color: "var(--ds-chart-categorical-1, #1d9aaa)",
  dataKey: 'churnRateBenchmark',
  legend: 'Churn Rate Benchmark'
}, {
  color: "var(--ds-chart-categorical-2, #5e4db2)",
  dataKey: 'isolatedChurnRateBenchmark',
  legend: 'Isolated Churn Rate Benchmark'
}];
export const getChartData = elements => {
  let lineChartData = [];
  if (elements.total.churnBenchmarkPerMonth != null) {
    lineChartData = _sortBy(elements.total.churnBenchmarkPerMonth, 'date').map(value => {
      return {
        xLabel: value.date,
        churnRateBenchmark: value.churnRateBenchmark,
        isolatedChurnRateBenchmark: value.isolatedChurnRateBenchmark
      };
    });
  }
  return lineChartData;
};
export const getChartTooltipPairs = payload => payload.map(item => {
  const dataKey = item.dataKey;
  const data = String(item.payload[dataKey]);
  return {
    color: item.color,
    label: item.name,
    value: data,
    isCharted: true
  };
});
const calculateTotalCountForBenchmark = elements => elements.reduce((total, current) => current + total, 0);
const getElementsForBenchmarkTable = (series, name) => {
  const elementsRow = [];
  series.forEach(item => {
    elementsRow.push(item[name]);
  });
  return elementsRow;
};
const getWeightedAverage = (element, weights) => {
  const [sum, weightSum] = weights.reduce((value, weight, index) => {
    value[0] = value[0] + element[index] * weight;
    value[1] = value[1] + weight;
    return value;
  }, [0, 0]);
  return sum / weightSum;
};
export const getBenchmarkArrayData = element => {
  if (element == null) return {};
  const total = calculateTotalCountForBenchmark(getElementsForBenchmarkTable(element, 'totalLicenses'));
  const churned = calculateTotalCountForBenchmark(getElementsForBenchmarkTable(element, 'churnedLicenses'));
  const data = {
    totalLicenses: total / element.length,
    churnedLicenses: churned / element.length,
    churnRate: churned / total,
    churnRateBenchmark: getWeightedAverage(getElementsForBenchmarkTable(element, 'churnRateBenchmark'), getElementsForBenchmarkTable(element, 'totalLicenses')) / 100,
    isolatedChurnRate: calculateTotalCountForBenchmark(getElementsForBenchmarkTable(element, 'isolatedChurnRate')) / (100 * element.length),
    isolatedChurnRateBenchmark: getWeightedAverage(getElementsForBenchmarkTable(element, 'isolatedChurnRateBenchmark'), getElementsForBenchmarkTable(element, 'totalLicenses')) / 100
  };
  return data;
};
export const getCloudChurnBenchmarkTableData = elements => {
  let tableData = [];
  if (elements.churnBenchmarkPerApp == null) return tableData;
  tableData = elements.churnBenchmarkPerApp.map(item => {
    const rowData = {
      appKey: item.appKey,
      appName: item.appName,
      data: getBenchmarkArrayData(item.churnBenchmarkPerMonth)
    };
    return rowData;
  });
  return tableData;
};
export const getCloudChurnBenchmarkSummaryData = elements => {
  let summaryData = {};
  if (elements == null) return summaryData;
  summaryData = {
    name: elements.total.name,
    data: getBenchmarkArrayData(elements.total.churnBenchmarkPerMonth)
  };
  return summaryData;
};
export const HeaderContentData = {
  churnRate: {
    name: 'Churn Rate',
    tooltip: 'Churn Rate'
  },
  churnRateBenchmark: {
    name: 'Churn Benchmark',
    tooltip: 'Churn Benchmark'
  },
  churnedLicenses: {
    name: 'Cancellations',
    tooltip: 'Cancellations'
  },
  isolatedChurnRate: {
    name: 'Isolated Churn Rate',
    tooltip: 'Isolated Churn Rate'
  },
  isolatedChurnRateBenchmark: {
    name: 'Isolated Churn Benchmark',
    tooltip: 'Isolated Churn Benchmark'
  },
  totalLicenses: {
    name: 'Customers',
    tooltip: 'Customers'
  }
};